import React, { useState } from 'react';
import { Button } from '../components/Button';
import { TextField } from '../components/Fields';
import { AuthLayout } from '../components/AuthLayout';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Circles } from 'react-loader-spinner';
import { getAuthHeaders, handleAuthError, requireAccessToken } from '../utils/auth';

function VerifyCodeForm() {
	const [vcode, setVcode] = useState('');
	const [checkNumberLoading, setCheckNumberLoading] = useState(false);
	const [verifyCodeMessage, setVerifyCodeMessage] = useState('');
	const [spinner, setSpinner] = useState(false);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const action = searchParams.get('action') || '';
	const isSupport = searchParams.get('support') !== null || window.location.search.includes('support');

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!requireAccessToken()) return;
		setCheckNumberLoading(true);

		axios.get(
			`https://maindashbe-june-b18731a0e161.herokuapp.com/selfservice/check-verification-code/${vcode}/${action === 'add_sca' ? 'sca' : 'aso'}`,
			{
				headers: getAuthHeaders()
			}
		)
			.then(res => {
				setSpinner(true);
				setVerifyCodeMessage(res.data.message);
				setCheckNumberLoading(false);
				if (res.data.message === 'Verification code is valid' && !isSupport) {
					navigate(`/selfservice/continuation/new-account?action=${action}&check_number=${res.data.account}&vcode=${vcode}`);
				} else {
					setSpinner(false);
				}
			})
			.catch(err => {
				if (handleAuthError(err)) return;
				setCheckNumberLoading(false);
				setSpinner(false);
			});
	};

	if (spinner) {
		return (
			<div className="w-[100%] h-[100vh] flex items-center justify-center">
				<Circles
					height="150"
					width="150"
					color="green"
					ariaLabel="loading"
				/>
			</div>
		);
	}

	return (
		<AuthLayout>
			<form onSubmit={handleSubmit}>
				<div className="grid grid-cols-1 gap-6">
					<h1 className="text-center font-medium text-[1.3rem]">{action === 'add_sca' ? 'Add Second Chance Account' : 'Add Aso Account'}</h1>
					<TextField
						className="col-span-full"
						label="Verification Code"
						id="verification_code"
						name="verification_code"
						type="verification_code"
						value={vcode}
						onChange={e => setVcode(e.target.value)}
						autoComplete="verification_code"
						required
					/>
				</div>
				<p className="text-center">{verifyCodeMessage}</p>
				<Button type="submit" color="cyan" className="mt-8 mb-5 w-full duration-200 hover:bg-gray-800 focus:bg-[#28a745] focus:text-white/80">
					{checkNumberLoading ? 'Checking' : 'Check'}
				</Button>
				<a className="underline" href="https://ft9ja.notion.site/How-to-Connect-Your-Account-to-Your-Dashboard-Using-FT9ja-Self-Service-FXTM-Accounts-1bbaa5a0912e80c7bd1dd880c037e0c5 " target="_blank" rel="noreferrer">
					<p className="text-center">Continuation guide</p>
				</a>
			</form>
		</AuthLayout>
	);
}

export default VerifyCodeForm;

